import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ISOTService } from '../../services';
import { CoreLogService } from "../../../core/services/log.service";
import { NumberPad } from "../../directives/numberPad/numberPad.component";

export interface voucherPinNumberPadDialogConfig {
  sot_service: ISOTService;
}

@Component({
  selector: "voucherNumberPadDialog",
  templateUrl: "./voucherPinNumberPadDialog.component.html",
  styleUrls: ["./voucherPinNumberPadDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VoucherPinNumberPadDialogComponent {
  private _sotService: ISOTService;
  @ViewChild("numberPad") numberPad: NumberPad;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<VoucherPinNumberPadDialogComponent, string>
    , @Inject(MAT_DIALOG_DATA) public voucherPinNumberPadDialogConfig: voucherPinNumberPadDialogConfig
    , private _coreLogService: CoreLogService) {
    const me = this;
    me._sotService = voucherPinNumberPadDialogConfig.sot_service;
  }

  public requiredVoucherPinLength: number = 4;
  public voucherPinValid: boolean = true;
  public inputMade: boolean = false;

  public get voucherPin(): string {
    const me = this;
    return me.numberPad.numberPadResult;
  }

  public get submitDisabled() {
    const me = this;
    return me.numberPad.submitDisabled;
  }

  public submit(): void {
    const me = this;
    if (me.submitDisabled) {
      me.voucherPinValid = true;
      me.dialogRef.close(me.voucherPin);
    } else {
      me.numberPad.toggleInputValid();
    }
    me.PushChanges();
  }

  public cancel(): void {
    const me = this;
    me.dialogRef.close("cancel");
  }
  public get isModeOne(): boolean {
    return this.voucherPinNumberPadDialogConfig.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.voucherPinNumberPadDialogConfig.sot_service.Accessabilty.useModeTwo;
  }

  public ngOnInit(): void {
    const me = this;
    me.PushChanges();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("VoucherPinNumberPadDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
}